import { useEffect, useState } from "react";
import api from "../../../api/axiosInstance";

const HomeAdmin = () => {
  const [form, setForm] = useState({
    badgeText: "",
    heading: "",
    subHeading: "",
    heroImageUrl: "",
    ctaPrimaryText: "",
    ctaSecondaryText: ""
  });

  const [loading, setLoading] = useState(true);

  // Load existing home data
  useEffect(() => {
    const load = async () => {
      try {
        const res = await api.get("/api/home");
        if (res.data) setForm(res.data);
      } catch (err) {
        console.error("Failed to load home hero");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/api/home", form);
      alert("Home Hero updated successfully");
    } catch (err) {
      alert("Failed to update Home Hero");
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="max-w-3xl space-y-6">
      <h1 className="text-2xl font-bold">Home Page – Hero Section</h1>

      <form onSubmit={submit} className="space-y-4">
        {[
          ["badgeText", "Badge Text"],
          ["heading", "Main Heading"],
          ["subHeading", "Sub Heading"],
          ["heroImageUrl", "Hero Image URL"],
          ["ctaPrimaryText", "Primary CTA Text"],
          ["ctaSecondaryText", "Secondary CTA Text"]
        ].map(([key, label]) => (
          <input
            key={key}
            className="w-full border p-2 rounded"
            placeholder={label}
            value={form[key] || ""}
            onChange={(e) =>
              setForm({ ...form, [key]: e.target.value })
            }
          />
        ))}

        <button className="bg-primary text-white px-4 py-2 rounded">
          Save Hero Section
        </button>
      </form>
    </div>
  );
};

export default HomeAdmin;
